import React, { useRef } from 'react';

export default function ContentRotator({ children }) {
  const ref = useRef();
  const scrollTo = (index) => {
    window.scrollBy(0, 1);
    ref.current.querySelectorAll('.slide')[index].scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'center',
    });
  };
  return (
    <div
      className="w-full overflow-x-auto snap-x snap-mandatory flex nobar"
      ref={ref}
    >
      <div className="shrink-0 w-[1024px]" />
      {children.map((item, index) => (
        <div
          onClick={() => scrollTo(index)}
          className="shrink-0 slide flex w-[1024px] max-w-full snap-center "
        >
          {item}
        </div>
      ))}

      <div className="shrink-0 w-[1024px]" />
    </div>
  );
}
